import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import FAQ from './FAQ';
import Home from './Home';
import HowItWorks from './HowItWorks';
import OurMembership from './OurMembership';
import OurPartner from './OurPartner';

function Landing() {

  return (
    <div className="space-y-16 lg:space-y-16 lg:mt-16 mt-12">
      <Home />
      <OurPartner />
      <OurMembership />
      <HowItWorks />
      {/* <SliderPage /> */}
      <AboutUs />
      <FAQ />
      <ContactUs />
    </div>
  );
}

export default Landing;
